import script from "./login-cermat.vue?vue&type=script&lang=js"
export * from "./login-cermat.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__